import { ActionFunction } from 'react-router-dom'

import Collection from '@models/Collection'
import CollectionItem from '@models/CollectionItem'
import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const addToCollectionAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const collection_id = formData.get('collectionId')
  const collection_type = formData.get('collectionType')
  const uuids = formDataToArray(formData.get('uuids'))
  const score_ids = formDataToArray(formData.get('scoreIds'))

  return http.action.post<AddToCollectionResponse>(ApiRoutes.collections.addPath(), {
    collection_id,
    collection_type,
    uuids,
    score_ids,
  })
}

export default addToCollectionAction

export type AddToCollectionResponse = {
  collection: Collection<unknown>
  collection_items: CollectionItem[]
  count: number
  failed: string[]
}
